// extracted by mini-css-extract-plugin
module.exports = {"root":"_3_-Ua","promoItemsBlockWrapper":"_10Wuw","campaignTextWrapper":"_1vXD-","title":"_1Mh6G","subtitle":"_2usCy","button":"_29cgl","itemsWrapper":"_3X08u","promoItem":"_1gMY4"};